import api from "@/config/apiConfig"

class ConnectionsController {

  async index () {
    try {
      const response = await api.get( `/channel` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/channel`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.create: ", error );
      throw error;
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/channel/${ req.id }`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.update: ", error );
      throw error;
    }
  }
  async getItem ( id ) {
    try {
      const response = await api.put( `/channel/${ id }` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.getItem: ", error );
      throw error;
    }
  }
  async delete ( id ) {
    try {
      const response = await api.delete( `/channel/${ id }` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.delete: ", error );
      throw error;
    }
  }

  async qrcode ( id ) {
    try {
      const response = await api.get( `/channel/${ id }/qrcode` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.qrcode: ", error );
      throw error;
    }
  }

  async status ( id ) {
    try {
      const response = await api.get( `/channel/${ id }/status` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.status: ", error );
      throw error;
    }
  }

  async desconnect ( id ) {
    try {
      const response = await api.delete( `/channel/${ id }/disconnect` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.desconnect: ", error );
      throw error;
    }
  }
  async loginInstagram ( id, token ) {
    try {
      const response = await api.post( `/channel/${ id }/login-instagram`, { token } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.loginInstagram: ", error );
      throw error;
    }
  }

  async getInstagramAuthorizeUrl () {
    try {
      const response = await api.get( `/channel/instagram/authorize` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.getInstagramAuthorizeUrl: ", error );
      throw error;
    }
  }

  async loginFacebook ( id, token ) {
    try {
      const response = await api.post( `/channel/${ id }/login-facebook`, { token } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.loginFacebook: ", error );
      throw error;
    }
  }

  async getFacebookAuthorizeUrl () {
    try {
      const response = await api.get( `/channel/facebook/authorize` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.getFacebookAuthorizeUrl: ", error );
      throw error;
    }
  }

  async getWhatsappAuthorizeUrl () {
    try {
      const response = await api.get( `/channel/whatsapp/authorize` );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.getWhatsappAuthorizeUrl: ", error );
      throw error;
    }
  }

  async whatsappCallback ( code, state ) {
    try {
      const response = await api.get( `/channel/whatsapp/callback`, { params: { code, state } } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.whatsappCallback: ", error );
      throw error;
    }
  }

  async whatsappFinalize ( channelId, accessToken, externalId ) {
    try {
      const response = await api.post( `/channel/whatsapp/finalize`, { channelId, accessToken, externalId } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.whatsappFinalize: ", error );
      throw error;
    }
  }


  async instagramCallback ( code, state ) {
    try {
      const response = await api.post( `/channel/instagram/callback/${state}`, { code } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.instagramCallback: ", error );
      throw error;
    }
  }

  async facebookCallback ( code, state ) {
    try {
      const response = await api.post( `/channel/facebook/callback/${state}`, { code } );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no ConnectionsController.facebookCallback: ", error );
      throw error;
    }
  }


}

export default new ConnectionsController();